module.exports = __webpack_public_path__ + "img/V-L-246-unload-standup-top.495b7dae.png";